module.exports = __webpack_public_path__ + "img/chin.0119a4ee.png";